<template>
  <div>
    <!-- <pre>
      {{fields}}
    </pre>-->
    <AppFlowTransition>
      <div :key="$route.params.step" v-if="page">
        <component v-bind:is="page.Component" :page="page" />
      </div>
    </AppFlowTransition>

    <AppNav :fields="fields" :hasError="errors" :page="page" />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import AppNav from '@/components/base/AppNav';
  import PersonInfo from '@/components/steps/PersonInfo';
  import Education from '@/components/steps/Education';
  import Start from '@/components/steps/Start';
  import Work from '@/components/steps/Work';
  import Student from '@/components/steps/Student';
  import LeaveOfAbsence from '@/components/steps/LeaveOfAbsence';
  import Consent from '@/components/steps/Consent';
  import Thanks from '@/components/steps/Thanks';
  import AppFlowTransition from '@/components/base/AppFlowTransition';
  import StudentInsurance from '@/components/steps/StudentInsurance';

  export default {
    components: {
      Start,
      PersonInfo,
      Education,
      Work,
      LeaveOfAbsence,
      Consent,
      Thanks,
      AppNav,
      AppFlowTransition,
      Student,
      StudentInsurance,
    },
    computed: {
      ...mapState(['pageData', 'newData']),
      page() {
        return this.newData.filter(
          (page) => page.Slug === this.$route.params.step
        )[0];
      },
    },
    mounted() {
      if (sessionStorage.getItem('employment')) {
        this.pageData.Steps[0].Questions[0].Value =
          sessionStorage.getItem('employment');
        this.$store.dispatch(
          'doNewData',
          Number(this.pageData.Steps[0].Questions[0].Value)
        );
      } else {
        this.$store.dispatch('doNewData');
      }
      setTimeout(() => {
        this.$validator.validate();
      }, 300);
    },
  };
</script>

<style lang="scss" scoped></style>
